<template>
  <div class="bj-section" style="padding-bottom: 200px">
    <div class="ubold-title" style="margin-bottom: 40px;">安全中心</div>
    <div class="bj-rows content-between bj-item">
      <div class="bj-rows">
        <span class="name">账户实名认证</span>
        <div class="label">{{ details.status | certificateStatus }} </div>
      </div>
      <div v-if="details.status !== 1" class="btn"  @click="showUpdateCertifiedModal">认证 ></div>
    </div>
    <div class="bj-rows content-between bj-item">
      <div class="bj-rows">
        <span class="name">登录密码</span>
        <div class="label">{{ details.hasPwd === 0 ? "未设置" : "已设置" }}</div>
      </div>
      <div class="btn"  @click="showUpdatePasswordModal">修改 ></div>
    </div>
    <div class="bj-rows content-between bj-item">
      <div class="bj-rows">
        <span class="name">账户邮箱</span>
        <div class="label">{{ !details.e ? "未设置" : details.e }}</div>
      </div>
      <div v-if="details.certificateStatus !== 1" class="btn"  @click="showEmail">{{ !details.e ? "设置 >" : "修改 >" }}</div>
    </div>
    <div class="bj-rows content-between bj-item">
      <div class="bj-rows">
        <span class="name">绑定手机</span>
        <div class="label">{{ !details.phone ? "未绑定" : details.phone }}</div>
      </div>
      <div class="btn"  @click="updatePhone">{{ !details.phone ? "设置 >" : "修改 >" }}</div>
    </div>
    <updateCertifiedModal
      :show.sync="updateCertifiedModalVisibility"
      @submit-success="onSuccess"
    ></updateCertifiedModal>
    <updatePasswordModal
      :show.sync="updatePasswordModalVisibility"
      @submit-success="onSuccess2"
    ></updatePasswordModal>
    <addEmailModal
      :show.sync="addEmailModalVisibility"
      @submit-success="onSuccess"
    ></addEmailModal>
    <updateEmailModal
      :show.sync="updateEmailModalVisibility"
      @submit-success="onSuccess"
    ></updateEmailModal>
    <updatePhoneModal
      :show.sync="updatePhoneModalVisibility"
      @submit-success="onSuccess"
    ></updatePhoneModal>
  </div>
</template>

<script>
import { securityCenter } from "api/user.js";
import updateCertifiedModal from "components/account/updateCertifiedModal.vue";
import updatePasswordModal from "components/account/updatePasswordModal.vue";
import addEmailModal from "components/account/addEmailModal.vue";
import updateEmailModal from "components/account/updateEmailModal.vue";
import updatePhoneModal from "components/account/updatePhoneModal.vue";

export default {
  name: "security",
  components: {
    updateCertifiedModal,
    updatePasswordModal,
    addEmailModal,
    updateEmailModal,
    updatePhoneModal,
  },
  filters: {
    certificateStatus(val) {
      let title = "";
      switch (val) {
        case -1:
          title = "未认证";
          break;
        case 0:
          title = "认证中";
          break;
        case 1:
          title = "认证成功";
          break;
        case 2:
          title = "认证失败";
          break;
      }
      return title;
    },
  },
  data() {
    return {
      details: {
        certificateNo: "",
        certificateStatus: 0,
        email: "",
        isHadPwd: 0,
        phoneNumber: "",
      },
      updateCertifiedModalVisibility: false,
      updatePasswordModalVisibility: false,
      addEmailModalVisibility: false,
      updateEmailModalVisibility: false,
      updatePhoneModalVisibility: false,
    };
  },
  created() {
    this.req_getInfo();
  },
  methods: {
    async req_getInfo() {
      try {
        const { code, data } = await securityCenter();
        if (code === 200) {
          this.details = data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async onSuccess(callback) {
      await this.req_getInfo();
      callback(true);
    },
    onSuccess2(callback) {
      callback(true);
    },
    showUpdateCertifiedModal() {
      this.updateCertifiedModalVisibility = true;
    },
    showUpdatePasswordModal() {
      this.updatePasswordModalVisibility = true;
    },
    showEmail() {
      this.updateEmailModalVisibility = true;
    },
    updatePhone() {
      this.updatePhoneModalVisibility = true;
    },
  },
};
</script>

<style lang="less" scoped>
.bj-item{
  padding: 30px 28px;
  border: 1px solid #737577;
  background-color: #28292C;
  border-radius: 6px;
  margin-top: 20px;
  &:first-child{
    margin-top: 0;
  }
  .icon{
    width: 16px;
    height: 20px;
  }
  .name{
    font-size: 16px;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 45px;
    margin: 0 25px;
  }
  .label{
    font-size: 14px;
    font-weight: 400;
    color: #737577;
  }
  .btn{
    color: #F85A36;
    cursor: pointer;
    padding: 10px 20px;
  }
}
</style>
